import { FilterGroup } from '@zero/shared/util-models';

export class PositionFilter {
  public isActive: boolean;
  public type: FilterGroup;

  constructor(type: FilterGroup, isActive = false) {
    this.type = type;
    this.isActive = isActive;
  }
}
